/*
  Waitlist (drop 1, email only). The form is Shopify's native customer form,
  so it works without this script; this only checks the email before sending
  and shows a loading state while the page submits.
*/
(function () {
  var form = document.getElementById('wl-form');
  var email = document.getElementById('wl-email');
  var submit = document.getElementById('wl-submit');
  var errorEl = document.getElementById('wl-error');
  if (!form || !email || !submit || !errorEl) return;

  form.addEventListener('submit', function (e) {
    var value = email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
      e.preventDefault();
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.hidden = false;
      email.focus();
      return;
    }
    email.value = value;
    errorEl.hidden = true;
    submit.disabled = true;
    submit.classList.add('is-loading');
  });

  email.addEventListener('input', function () { errorEl.hidden = true; });
})();
